import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { sendContact } from "../../redux/bases";
import { Link } from "react-router-dom";
import image_footer from "../img/orocash_bicolor.png";

const Footer = () => {
  const envio_contacto = useSelector((store) => store.bases.contacto);
  const dispatch = useDispatch();
  const [mensaje, setMensaje] = useState({ type: "", msj: "" });
  useEffect(() => {
    if (envio_contacto === 200) {
      setMensaje({ msj: "Se envió correctamente", type: "success" });
    } else if (envio_contacto === 1) {
      setMensaje({ msj: "Ocurrio un error al enviar", type: "danger" });
    }
  }, [envio_contacto]);
  const [data, setData] = useState({
    nombre: "",
    correo: "",
    asunto: "",
    mensaje: "",
  });

  const onInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { nombre, mensaje, asunto, correo } = data;
    if (nombre === "" || mensaje === "" || asunto === "" || correo === "") {
      setMensaje({ msj: "Todos los campos son obligatorios", type: "danger" });
    } else {
      dispatch(sendContact(data));
    }
  };

  return (
    <>
      <section id="contact" class="contact-area mt-3">
        <div class="container">
          <div class="row">
            <div class="col-md-12 section-title">
              <h2>Contáctenos</h2>
              <div class="bar"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 col-md-12">
              <div class="contact-info">
                <ul>
                  <li class="hob">
                    <div class="icon icon-bg-1">
                      <i class="fa fa-map-marker"></i>
                    </div>
                    <span>Dirección</span>
                    Chile y Vélez 131, &amp; Edificio Orocash, Guayaquil, Ecuador
                  </li>
                  <li>
                    <div class="icon icon-bg-2">
                      <i class="fa fa-envelope"></i>
                    </div>
                    <span>Email</span>
                    {/* eslint-disable-next-line */}
                    <a href="#">contactenos@orocash.ec</a>
                  </li>
                  <li>
                    <div class="icon icon-bg-3">
                      <i class="fa fa-phone"></i>
                    </div>
                    <span>Teléfono</span>
                    {/* eslint-disable-next-line */}
                    <a href="#">+5930994480427</a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-7 col-md-12">
              <p class="form-message"></p>
              <br />
              <form
                class="contact-form form"
                onSubmit={(e) => handleSubmit(e)}
                method="POST"
              >
                <div class="controls">
                  <div class="row">
                    {mensaje.msj !== "" ? (
                      <div class={`alert alert-${mensaje.type} m-3`}>
                        {mensaje.msj}
                      </div>
                    ) : null}
                    <div class="col-lg-6 col-md-12">
                      <div class="form-group has-error has-danger">
                        <input
                          id="form_name"
                          type="text"
                          name="nombre"
                          onChange={(e) => onInputChange(e)}
                          placeholder="Tu Nombre"
                          required="required"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                      <div class="form-group has-error has-danger">
                        <input
                          id="form_email"
                          type="email"
                          name="correo"
                          onChange={(e) => onInputChange(e)}
                          placeholder="Tu Email"
                          required="required"
                        />
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                      <div class="form-group has-error has-danger">
                        <input
                          id="form_subject"
                          type="text"
                          name="asunto"
                          onChange={(e) => onInputChange(e)}
                          placeholder="Tu Asunto"
                          required="required"
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <textarea
                          id="form_message"
                          name="mensaje"
                          onChange={(e) => onInputChange(e)}
                          placeholder="Tu Mensaje"
                          rows="4"
                          required="required"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <button type="submit" class="button">
                        Enviar mensaje
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <div class="responsive-map-container mt-4">
        {/* eslint-disable-next-line */}
        <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d382.20142774105705!2d-79.8822213978477!3d-2.192416594109004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x902d6fb8aa5173f3%3A0x6b28fc4da13910e3!2sOrocash!5e0!3m2!1ses-419!2sec!4v1759929575274!5m2!1ses-419!2sec"
          width="1920"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>

      <footer class="footer">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-6 footer-content">
              <div class="footer-colm-1">
                  {/* eslint-disable-next-line*/}
                  <img src={image_footer} width={250} />
                {/*<h3 class="footer-logo">OROCASH</h3>*/}
                {/*<p>*/}
                {/*  Empresa líder en calidad de servicio con cobertura nacional{" "}*/}
                {/*</p>*/}
              </div>
            </div>
            <div class="col-lg-2 col-md-6 footer-content">
              <div class="footer-colm-2">
                <h5 class="footer-colm-title">Nosotros</h5>
                <ul class="footer-nav">
                  {/*<li>*/}
                  {/*  /!* eslint-disable-next-line *!/*/}
                  {/*  <a href="#">Quiénes somos</a>*/}
                  {/*</li>*/}
                  <li>
                    {/* eslint-disable-next-line */}
                    <a href="#">Contáctenos</a>
                  </li>
                  <li>
                    {/* eslint-disable-next-line */}
                    <a href="#"></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-2 col-md-6 footer-content">
              <div class="footer-colm-3">
                <h5 class="footer-colm-title">Soporte</h5>
                <ul class="footer-nav">
                  {/*<li>*/}
                  {/*  <Link to="/terminos">Términos y condiciones</Link>{" "}*/}
                  {/*</li>*/}
                  <li>
                    <Link to="/politicas">Cláusula de consentimiento</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 footer-content">
              <div class="footer-colm-4 footer-subscribe">
                <h5 class="footer-colm-title">Información de contacto</h5>

                <p>
                  <a href="mailto:contactenos@orocash.com">
                    contactenos@orocash.com
                  </a>
                </p>
                <p>
                  <a href="tel:+5930994480427">+5930994480427</a>
                </p>
              </div>
            </div>
          </div>
          <div class="border-shadow-2"></div>
          <div class="row">
            <div class="col-md-12">
              <div class="copyright-text text-center">
                <p>OROCASH © {new Date().getFullYear()}</p>
                <p>
                  {/* eslint-disable-next-line */}
                  Designed by <a href="#">Innode.</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
